import "./layout.scss";
import SideBar from "./Sidebar/SideBar";
import Navbar from "./Navbar/Navbar";
import { Outlet, useLocation } from "react-router-dom";
import { useState } from "react";
import { useSelector } from "react-redux";
import { AUTO_PRINT_STORAGE_KEY } from "constants/autoPrint";
import ImpersonationBanner from "components/Ui/ImpersonationBanner/ImpersonationBanner";
import VendorWalletBanner from "components/Ui/VendorWalletBanner/VendorWalletBanner";
import ErrorBoundary from "components/Ui/ErrorBoundary/ErrorBoundary";
import PageErrorFallback from "components/Ui/ErrorBoundary/PageErrorFallback";

const Layout = (props) => {
    const location = useLocation();
    const adminInfo = useSelector((state) => state.auth.userData);
    const isVendorDashboard = adminInfo?.role === "vendor";
    const [autoPrintConfigured, setAutoPrintConfiguredState] = useState(() => {
        return localStorage.getItem(AUTO_PRINT_STORAGE_KEY) === "true";
    });

    const setAutoPrintConfigured = (value) => {
        const nextValue = Boolean(value);
        setAutoPrintConfiguredState(nextValue);
        localStorage.setItem(AUTO_PRINT_STORAGE_KEY, String(nextValue));
    };

    return (
        <>
            <ImpersonationBanner />
            <SideBar />
            <Navbar
                newOrder={props.newOrder}
                autoPrintConfigured={autoPrintConfigured}
                isVendorDashboard={isVendorDashboard}
            />
            <main>
                {/* A restaurant's own dashboard only: why it takes no orders when
                    the wallet has closed it (api#147). Renders nothing otherwise.
                    INSIDE <main>, not before the navbar: the navbar and the
                    sidebar are position: fixed, so anything in the flow above
                    them sits under the navbar and is cut off. */}
                {isVendorDashboard ? <VendorWalletBanner /> : null}
                {/* keyed by pathname so navigating away from a crashed page
                    resets the boundary — the sidebar/navbar stay usable */}
                <ErrorBoundary key={location.pathname} fallback={<PageErrorFallback />}>
                    <Outlet
                        context={{
                            autoPrintConfigured,
                            isVendorDashboard,
                            setAutoPrintConfigured,
                        }}
                    />
                </ErrorBoundary>
            </main>
        </>
    );
};
export default Layout;
